/**
 * @generated SignedSource<<1dd9b028e845a79d76aa622e3db145ed>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftNav_viewer$data = {
  readonly nftMintBlogEnabled: boolean | null;
  readonly nftSearchEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftSearchBarMobile_viewer" | "NftSearchBar_viewer">;
  readonly " $fragmentType": "NftNav_viewer";
};
export type NftNav_viewer$key = {
  readonly " $data"?: NftNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftNav_viewer",
  "selections": [
    {
      "alias": "nftMintBlogEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftMintBlog"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftMintBlog\")"
    },
    {
      "alias": "nftSearchEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftSearch"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftSearch\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftSearchBar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftSearchBarMobile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3fb087012f8d783aa9c9d166fb275370";

export default node;
